import { render } from "./OpenServicesTable.vue?vue&type=template&id=005ba215"
import script from "./OpenServicesTable.vue?vue&type=script&lang=js"
export * from "./OpenServicesTable.vue?vue&type=script&lang=js"

import "./OpenServicesTable.vue?vue&type=style&index=0&id=005ba215&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__